import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import Container from '@/components/web/Container.vue';
import bannerBread from '@/components/web/bannerBread.vue';
import { ref, reactive, onBeforeMount, onServerPrefetch, computed } from 'vue';
import CaseStudiesView from '@/components/web/content/CaseStudiesView.vue';
import { useRoute } from 'vue-router'
import { caseStudiesData } from '@/data/caseStudies'
import { useCaseStudiesMeta } from '@/composables/useCaseStudiesMeta'

//使用封装好的 meta 设置
type BreadcrumbItem = {
    text: string;
    to?: string;  // 可选的路由路径
}

export default /*@__PURE__*/_defineComponent({
  __name: 'case-studies-view',
  setup(__props) {

const route = useRoute()

// 从完整路径中提取 ID
const fullPath = computed(() => route?.path || '')
const caseId = computed(() => {
  const path = fullPath.value
  return path.split('/case-studies/')[1] || ''
})

const title = ref('')
const productInfo = ref<productInfoType>({
    ManufacturingProcess: '',
    PartsMaterial: '',
    ApplicationIndustry: '',
    SurfaceTreatment: '',
    MetalState: '',
    MachineUsedType: '',
    HardnessOfParts: '',
    Fillet: '',
    DemouldingAngle: '',
    Roughness: '',
    Accuracy: ''
} as productInfoType)

const contentWithImg = ref<ContentWithImg>({
    h2Title: '',
    pList: [],
    img: []
} as ContentWithImg)


const imageData = ref<imageAltItem[]>([])
const advantageProps = ref<advantageType>({
    h2Title: "Our Parts Manufacturing Advance Capability",
    pTitle: "Our molds are processed independently, without additional profit, moderate cost, short cycle, and sample out at the fastest 20 days, and all our company's ex-factory die-casting parts and unqualified products are returned and exchanged unconditionally without reason."
} as advantageType)
const productCollection = ref<imageAltTitleItem[]>([]);

// 轮播图
// 将 reactive 改为 ref
const bannerImages = ref<imageAltItem[]>([]);

// 动态面包屑数据
// 定义面包屑项目的数据结构
const breadcrumbItems = reactive<BreadcrumbItem[]>([
    { text: 'Home', to: '/' }
]);

//优势集合
const advantageCollection = reactive<picturetitleAltItem[]>([]);
//优势图片
const viewadvantageCollection = reactive<picturetitleItem[]>([]);
//产品展示的图片
const viewPartsCollection = reactive<picturetitleItem[]>([]);
//荣誉证书集合
const honorCertificatesCollection = reactive<picturetitleItem[]>([]);
//认识压铸车间集合
const dieCastingWorkshopCollection = reactive<imgItem[]>([]);

const caseData = ref(caseStudiesData[caseId.value])//初始化ref
// console.log("路径参数:", caseId)

useCaseStudiesMeta(caseId.value)

// 填充数据的函数
const populateData = (data: CaseStudyData) => {
    title.value = data.title
    productInfo.value = data.productInfo
    contentWithImg.value = data.contentWithImg
    imageData.value = data.images
    productCollection.value = data.productCollection
    advantageProps.value = data.advantage || {
        h2Title: "Our Parts Manufacturing Advance Capability",
        pTitle: "Our molds are processed independently, without additional profit, moderate cost, short cycle, and sample out at the fastest 20 days, and all our company's ex-factory die-casting parts and unqualified products are returned and exchanged unconditionally without reason."
    }
    populateProductCollection()
}

//服务端预取数据
onServerPrefetch(async () => {
    // 在服务端渲染时，直接从路径中提取 ID
    const path = route?.path || ''
    const id = path.split('/case-studies/')[1] || ''
    
    if (id && caseStudiesData[id]) {
        caseData.value = caseStudiesData[id]
        // 填充数据
        populateData(caseData.value);
    } else {
        console.log('未找到数据:', { id, availableKeys: Object.keys(caseStudiesData) })
    }
})

// 客户端加载
onBeforeMount(() => {
    if (caseId.value && caseStudiesData[caseId.value]) {
        caseData.value = caseStudiesData[caseId.value]
        // 填充数据
        populateData(caseData.value)
    }
})

// 填充产品集合的函数
const populateProductCollection = () => {
    // 填充通用数据
    // 清空现有数据
    bannerImages.value = [];

    // 填充数据
    bannerImages.value.push({
        imgUrl: 'https://c74.hongcdn.com/uploads/2102/case-studies-!j.webp',
        alt: 'China Best Die Casting Parts - Metal Parts Case Studies'
    });

// 数据填充函数
    advantageCollection.push(
        {
            imgUrl: "https://www.diecastingcompany.com/uploads/2102/china-top-die-cast-parts-drawing-designs.jpg",
            alt: "china-top DFM Drawing design",
            title: "1. Drawing Design",
            text: "DFM is one of the best methods followed by Minghe engineers to optimize the manufacturability of castings while retaining functionality. Minghe has a team of more than ten professional engineers who will provide effective suggestions on material structure and find a balance between design, cost and part performance."
        },
        {
            imgUrl: "https://www.diecastingcompany.com/uploads/2102/mold-design.jpg",
            alt: "mold-design",
            title: "2. Mold Design",
            text: "The mold stage simulates the filling flow and solidification process, predicts the defects that will appear in the die casting, and predicts the microscopic metal and mechanical properties, and the strength of the mold ejector pin. Optimize runner and gate design, improve production process parameters, reduce R&D and production costs, and improve casting product quality."
        },
        {
            imgUrl: "https://www.diecastingcompany.com/uploads/2102/mold-manufacturing.jpg",
            alt: "Mold-Manufacturing",
            title: "3. Mold Manufacturing",
            text: "Minghe's multi-slider mold manufacturing technology allows us to put the part structure into the mold to the greatest extent when making the mold, and the parts are formed at one time, reducing the cost of multi-component production and assembly and secondary processing."
        },
        {
            imgUrl: "https://www.diecastingcompany.com/uploads/2102/die-casting-process.jpg",
            alt: "Die casting ability",
            title: "4. Die-Cast Ability",
            text: "Minghe is one of the few companies with the ability to expand the casting range, with die casting machines of 58-3000 tons of different tonnage. It can produce parts weighing 5g-35kg. The independent furnace of each die casting machine enables us to provide a variety of aluminum, zinc, magnesium and their alloys to meet the unique needs of customers."
        },
        {
            imgUrl: "https://www.diecastingcompany.com/uploads/2102/cnc-machining.jpg",
            alt: "CNC machining ability",
            title: "5. Cnc Machining Ability",
            text: "Minghe has an experienced and mature cnc machining team, more than ten imported processing centers and lathes, and its own processing brand PTJ Shop is one of the top ten small and medium-sized processing manufacturers in China. It provides reliable precision for processing. The minimum tolerance is controlled by 0.22mm to meet the needs of parts. Assembly requirements on the client side."
        },
        {
            imgUrl: "https://www.diecastingcompany.com/uploads/2102/surface-treatment.jpg",
            alt: "surface-treatment",
            title: "6. Surface Treatment Ability",
            text: "Minghe can complete the physical surface treatment and powder spraying treatment such as shot blasting, fine sand, coarse sand and so on. At the same time, Minghe has been deeply involved in the local supply chain for more than 30 years, strategically integrating dozens of chemical surface treatment suppliers, and through the management of complex supply chains, to provide customers with surface treatment such as plastic spraying, painting, anodizing, electrophoresis, chrome plating, etc."
        },
        {
            imgUrl: "https://www.diecastingcompany.com/uploads/2102/assembly.jpg",
            alt: "Assembly ability",
            title: "7. Assembly Ability",
            text: "Minghe provides customers with a variety of mechanical assembly and sub-assembly services. We have extensive experience in assembling hardware, including screws, screws, bolts, pins, inserts, gaskets and O-rings, and pressure seal testing to ensure product functionality."
        },
        {
            imgUrl: "https://www.diecastingcompany.com/uploads/2102/cmm.jpg",
            alt: "CMM Quality Inspection",
            title: "8. Quality Inspection System",
            text: "Minghe pays special attention to the quality control of the mass production process and has established a complete quality inspection process and system. Five tools are commonly used: PPAP, APQP, PFMEA, SPC, and MSA. All products are fully inspected or constructed in accordance with the standards. Testing equipment includes: spectrometer, stretching Testing machine, CMM three-coordinate, pass-stop gauge, parallel gauge, various calipers, etc., to achieve the control ability of the quality system."
        }
    );
    viewadvantageCollection.push(
        { imgUrl: "https://www.diecastingcompany.com/uploads/2102/our-die-casting-machine.jpg", alt: "our die casting machine", title: "Our Die Casting Machine" },
        { imgUrl: "https://www.diecastingcompany.com/uploads/2102/our-cnc-machining-machine.jpg", alt: "Minghe Cnc Machining Machine", title: "Our Cnc Machining Machine" },
        { imgUrl: "https://www.diecastingcompany.com/uploads/2102/test-minghe-quipment.jpg", alt: "Minghe Test Quipment", title: "Test Quipment" },
        { imgUrl: "https://www.diecastingcompany.com/uploads/2102/minghe-packaging-pohot.jpg", alt: "Minghe Packaging Process", title: "Our Packaging Process" },
        { imgUrl: "https://www.diecastingcompany.com/uploads/2102/customer-photo.jpg", alt: "Minghe Customer Photo", title: "Customer Photo" },
        { imgUrl: "https://www.diecastingcompany.com/uploads/2102/simple-display.jpg", alt: "Minghe Simple Display", title: "Our Simple Display" }
    );

    viewPartsCollection.push(
        { imgUrl: "https://www.diecastingcompany.com/uploads/2102/automotive-parts.jpg", alt: "Automotive Parts Die Casting", title: "Automotive Parts Die Casting" },
        { imgUrl: "https://www.diecastingcompany.com/uploads/2102/natural-gas-valve.jpg", alt: "Die Casting Natural Gas Valve", title: "Die Casting Natural Gas Valve" },
        { imgUrl: "https://www.diecastingcompany.com/uploads/2102/security-equipment-enclosure.jpg", alt: "Die Casting Security Equipment Enclosure", title: "Die Casting Security Equipment Enclosure" },
        { imgUrl: "https://www.diecastingcompany.com/uploads/2102/air-pump-housing.jpg", alt: "Air Pump Housing Die Casting", title: "Air Pump Housing Die Casting" },
        { imgUrl: "https://www.diecastingcompany.com/uploads/2102/lighting-housing.jpg", alt: "Die Casting Lighting Housing", title: "Die Casting Lighting Housing" },
        { imgUrl: "https://www.diecastingcompany.com/uploads/2102/motor-accessories.jpg", alt: "Die Casting Motor Accessories", title: "Die Casting Motor Accessories" },
        { imgUrl: "https://www.diecastingcompany.com/uploads/2102/construction-hardware.jpg", alt: "Construction Hardware Die Casting", title: "Construction Hardware Die Casting" },
        { imgUrl: "https://www.diecastingcompany.com/uploads/2102/jewelry-die-casting.jpg", alt: "Die Casting Jewelry", title: "Zinc Die Casting Jewelry" },
        { imgUrl: "https://www.diecastingcompany.com/uploads/2102/more-die-casting-parts.jpg", alt: "More Die Casting Parts", title: "More Die Casting Parts" }
    );

    honorCertificatesCollection.push(
        {
            imgUrl: "https://c74.hongcdn.com/uploads/2102/hk-minghe-manufacture-industry-limited-business-license-business-license2-!j.webp",
            alt: "HK Minghe Manufacture Industry Limited Business License Business License 2",
            title: "HK Minghe Manufacture Industry Limited Business License Business License 2"
        },
        {
            imgUrl: "https://c74.hongcdn.com/uploads/2102/hk-minghe-manufacture-industry-limited-business-license-business-license1-!j.webp",
            alt: "HK Minghe Manufacture Industry Limited Business License Business License 1",
            title: "HK Minghe Manufacture Industry Limited Business License Business License 1"
        },
        {
            imgUrl: "https://c74.hongcdn.com/uploads/2102/minghe-occupational-health-license-!j.webp",
            alt: "Minghe Occupational Health License",
            title: "Minghe Occupational Health License"
        },
        {
            imgUrl: "https://c74.hongcdn.com/uploads/2102/minghe-iso-14001-!j.webp",
            alt: "Minghe ISO 14001 Certificate",
            title: "Minghe ISO 14001 Certificate"
        }
    );

    dieCastingWorkshopCollection.push(

        {
            imgUrl: "https://c74.hongcdn.com/uploads/2102/aluminum-die-casting-shop-imag-1-!j.webp",
            text: "Aluminum Die Casting "
        },
        {
            imgUrl: "https://c74.hongcdn.com/uploads/2102/china-minghe-trimming-machine-!j.webp",
            text: "China Minghe Trimming Machine"
        },
        {
            imgUrl: "https://c74.hongcdn.com/uploads/2102/china-minghe-shot-blasting-machine-!j.webp",
            text: "China Minghe Shot Blasting Machine "
        },
        {
            imgUrl: "https://c74.hongcdn.com/uploads/2102/finished-product-workshop-in-china-minghe-!j.webp",
            text: "Finished Product Workshop In China Minghe"
        },
        {
            imgUrl: "https://c74.hongcdn.com/uploads/2102/finishing-workshop-in-china-minghe-!j.webp",
            text: "Minghe Precision Processing Workshop, China"
        },
    );
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Container, null, {
    "header-banner": _withCtx(() => [
      _createVNode(bannerBread, {
        "banner-images": bannerImages.value,
        "breadcrumb-items": breadcrumbItems
      }, null, 8, ["banner-images", "breadcrumb-items"])
    ]),
    content: _withCtx(() => [
      _createVNode(CaseStudiesView, {
        "view-parts-collection": viewPartsCollection,
        "viewadvantage-collection": viewadvantageCollection,
        "advantage-collection": advantageCollection,
        contentWithImg: contentWithImg.value,
        title: title.value,
        "image-list": imageData.value,
        "advantage-props": advantageProps.value,
        "product-info": productInfo.value,
        "honor-certificates-collection": honorCertificatesCollection,
        "die-casting-workshop-collection": dieCastingWorkshopCollection,
        productCollection: productCollection.value
      }, null, 8, ["view-parts-collection", "viewadvantage-collection", "advantage-collection", "contentWithImg", "title", "image-list", "advantage-props", "product-info", "honor-certificates-collection", "die-casting-workshop-collection", "productCollection"])
    ]),
    _: 1
  }))
}
}

})